import axios from "axios"

axios.defaults.baseURL = 'https://lapi.ibrpa.com/';

export default axios;